import { c as createRenderFn } from "./createRenderFn.js";
import { c as createSetupFn } from "./createSetupFn.js";
const createProxyComponent = (component) => {
  const setupFn = createSetupFn(component);
  const renderFn = createRenderFn(component);
  return new Proxy(component, {
    get(target, key) {
      if (!(key in component)) {
        return Reflect.get(target, key);
      }
      if (key === "setup") {
        return setupFn;
      }
      if (key === "render" || key === "ssrRender") {
        return renderFn;
      }
      return Reflect.get(target, key);
    }
  });
};
export {
  createProxyComponent as c
};
//# sourceMappingURL=createProxyComponent.js.map
